import { useContext } from 'react';
import AuthContext from '../contexts/CustomContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
